import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import Input from '../../../components/ui/Input';

const NewsletterSection = () => {
  const [email, setEmail] = useState('');
  const [subscribed, setSubscribed] = useState(false);

  const handleSubscribe = (e) => {
    e?.preventDefault();
    if (email) {
      setSubscribed(true);
      setTimeout(() => {
        setEmail('');
        setSubscribed(false);
      }, 3000);
    }
  };

  return (
    <section className="bg-card border border-border rounded-lg p-6 md:p-8 lg:p-10">
      <div className="max-w-2xl mx-auto text-center">
        <div className="flex justify-center mb-4">
          <div className="flex items-center justify-center w-16 h-16 rounded-full bg-primary/10">
            <Icon name="Mail" size={32} color="var(--color-primary)" />
          </div>
        </div>

        <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground mb-3">
          Stay Updated with Technical Insights
        </h2>
        
        <p className="text-base md:text-lg text-muted-foreground mb-6">
          Get the latest articles, tutorials, and industry perspectives delivered to your inbox. No spam, unsubscribe anytime.
        </p>

        {subscribed ? (
          <div className="flex items-center justify-center gap-2 p-4 rounded-lg bg-success/10 text-success">
            <Icon name="CheckCircle" size={20} />
            <span className="font-medium">Successfully subscribed! Check your email.</span>
          </div>
        ) : (
          <form onSubmit={handleSubscribe} className="flex flex-col sm:flex-row gap-3">
            <Input
              type="email"
              placeholder="Enter your email address"
              value={email}
              onChange={(e) => setEmail(e?.target?.value)}
              required
              className="flex-1"
            />
            <Button
              type="submit"
              variant="default"
              iconName="Send"
              iconPosition="right"
              className="sm:w-auto"
            >
              Subscribe
            </Button>
          </form>
        )}

        <p className="text-xs text-muted-foreground mt-4">
          Join 2,500+ developers receiving weekly insights
        </p>
      </div>
    </section>
  );
};

export default NewsletterSection;